import { BrowserRouter , Route, Routes } from 'react-router-dom';
import Error404Page from './pages/partial/Error404Page'
import IndexPage from './pages/IndexPage';

import WelcomePage from './pages/WelcomePage';
import MainPage from './pages/MainPage';
import ProtectedRoute from './services/ProtectedRoute.service'

const userProfile = 'MAX'

function App() {
  return (
    <BrowserRouter future={{v7_startTransition: true,v7_relativeSplatPath: true}}>
      <Routes>

        {<Route path="/login" element={<WelcomePage/>}/>}

        {<Route path="/" element={<IndexPage/>}/>}
        
        {
          /*
          <Route path="/"
            element={
              <ProtectedRoute 
                profile={userProfile} 
                routeName='inicio'
                element={MainPage} 
              />
            }
          />
          */
        }
        
        <Route path="*" element={<Error404Page/>}/>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
